import { gql } from '@apollo/client'

export const CORE_CHAPTER_RESULT_FIELDS = gql`
	fragment CoreChapterResultFields on ChapterResult {
		id
		chapterId
		timeSpent
		parts {
			id
			type
			title
			scene
			question
			instruction
			answer
			correctAnswer
			options
		}
	}
`

export const APPLICANTS_SCORE_SKILLS_FIELD = gql`
	fragment ApplicantsScoreSkillsFields on ScoreSkill {
		score
		skillId
		skill {
			id
			name
		}
		chapter {
			id
			name
		}
	}
`

export const APPLICANTS_SCORE_FIELDS = gql`
	fragment ApplicantsScoreFields on ScoreApplicant {
		id
		score
		skills {
			...ApplicantsScoreSkillsFields
		}
	}
`

export const APPLICANT_FIELDS = gql`
	fragment ApplicantFields on Applicant {
		id
		progress
		type
		isBookmarked
		isShortlisted
		masking
		note
		customFields
		pipelineType
		pipelinesId
		submission {
			...CoreChapterResultFields
		}
		score {
			...ApplicantsScoreFields
		}
		pipelines {
			id
			name
			color
			type
		}
		user {
			id
			email
			location
			firstName
			lastName
			photoUrl
			skills
			linkedinLink
			resumeLink
			eduLevel
			roleFunction
			roleInterests
			profYear
			username
			hasSandbox
		}
		createdAt
	}
`

export const GET_APPLICANT = gql`
	query GetApplicant($userId: ID!, $assessId: ID!) {
		applicant(userId: $userId, assessId: $assessId) {
			...ApplicantFields
		}
	}
`

export const CORE_APPLICANT_ITEM_FIELDS = gql`
	fragment CoreApplicantItemFields on Applicant {
		id
		progress
		isBookmarked
		masking
		score {
			...ApplicantsScoreFields
		}
		pipelinesId
		pipelineType
		pipelines {
			id
			name
			color
			type
		}
		user {
			id
			firstName
			lastName
			photoUrl
		}
		createdAt
	}
`

export const GET_APPLICANTS = gql`
	query GetApplicants(
		$assessId: ID!
		$page: Int
		$filter: FilterApplicantGetManyInput
		$sort: EnumSortApplicantGetManyInput
		$type: EnumPipelineType
	) {
		applicants(
			assessId: $assessId
			page: $page
			filter: $filter
			sort: $sort
			type: $type
		) {
			items {
				...CoreApplicantItemFields
			}
			totalTalents {
				count
				employees
				candidates
			}
			pageInfo {
				currentPage
				perPage
				pageCount
				itemCount
				hasNextPage
				hasPreviousPage
			}
			count
		}
	}
	${CORE_APPLICANT_ITEM_FIELDS}
	${APPLICANTS_SCORE_FIELDS}
	${APPLICANTS_SCORE_SKILLS_FIELD}
`

export const UPDATE_APPLICANT = gql`
	mutation UpdateApplicant(
		$userId: ID!
		$assessId: ID!
		$applicantInput: UpdateApplicantInput!
	) {
		updateApplicant(assessId: $assessId, userId: $userId, applicantInput: $applicantInput) {
			id
			isBookmarked
			isShortlisted
			note
			user {
				id
				firstName
				lastName
				photoUrl
			}
			pipelinesId
			pipelineType
			pipelines {
				id
				name
				color
				type
			}
		}
	}
`

export const DELETE_APPLICANT = gql`
	mutation DeleteApplicant($userId: ID!, $assessId: ID!) {
		deleteApplicant(userId: $userId, assessId: $assessId)
	}
`

export const BULK_ADD_TALENTS = gql`
	mutation BulkAddTalents($pipelineId: ID!, $users: JSON!) {
		bulkAddTalents(pipelineId: $pipelineId, users: $users)
	}
`
